import { useAppbarTitle } from '@hooks/useAppbarTitle';
import { usePageTitle } from '@hooks/usePageTitle';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

export function MyFarmPage() {
	const { t } = useTranslation();

	useAppbarTitle('myFarm.myFarm');
	usePageTitle(t('myFarm.myFarm'));

	return <Outlet />;
}
